export const links = [
    {
        label: "Task Assignments",
        path: "/admin/assignment/tasks",
        activePaths: ["admin/assignment/tasks"],
    },
    {
        label: "Pre-Task Workflows",
        path: "/admin/assignment/workflows",
        activePaths: ["admin/assignment/workflows"],
    },
];
